import { Navigate, useLocation } from "react-router-dom";
import { useCustomer } from "../contexts/CustomerContext";

function CustomerProtectedRoute({ children }) {
  const { isAuthorized } = useCustomer();
  const location = useLocation();

  // null หมายถึง Provider กำลังตรวจสอบสิทธิ์
  if (isAuthorized === null) {
    return <div>Loading...</div>;
  }

  // ตรวจเสร็จแล้ว แต่ไม่ได้ Login
  if (isAuthorized === false) {
    return (
      <Navigate
        to="/support"
        replace
        state={{ from: location.pathname }}
      />
    );
  }

  return children;
}

export default CustomerProtectedRoute;